import api from "../../services/api";

const useFavoriteMessages = () => {
  const create = async ({ messageId, label }) => {
    const { data } = await api.request({
      url: "/favorites",
      method: "POST",
      data: { messageId, label }
    });
    return data;
  };

  const list = async (params) => {
    const { data } = await api.request({
      url: "/favorites",
      method: "GET",
      params
    });
    return data;
  };

  const remove = async (id) => {
    const { data } = await api.request({
      url: `/favorites/${id}`,
      method: "DELETE"
    });
    return data;
  };

  return {
    create,
    list,
    remove
  };
};

export default useFavoriteMessages;
